import {
    NinchatActionType,
    NinchatDeleteUserAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
    NinchatActionPayload,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const deleteUser = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDeleteUserAction}`,
    async (arg: NinchatActionParams<NinchatDeleteUserAction> & NinchatActionPayload, {rejectWithValue}) => {
        const {
            payload,
            ...params
        } = arg

        params.action = NinchatActionType.NinchatDeleteUserAction

        try {
            return await ninchatClient.send(params, payload)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
